function Health() {
  return <span>alive</span>;
}

export default Health;
